export default __webpack_public_path__ + "static/media/focus-on-cores-mobile.f8c955c1.png";